import styles from './EventInfo.module.scss';

import { format } from 'legacy/common/utils/datetime';

import { EventForUser } from 'legacy/events/types';

type EventInfoProps = {
  event: EventForUser;
};

const EventInfo: React.FC<EventInfoProps> = ({ event }) => (
  <div className={styles.info}>
    <h1 className={styles.title}>{event?.title}</h1>
    <div className={styles.location}>{event.address}</div>
    <div className={styles.time}>
      {format(event.startDate)}
      {!!event.endDate && ` - ${format(event.endDate)}`}
    </div>
  </div>
);

export default EventInfo;
